import fetch from 'isomorphic-fetch';
// * snip 

var getApiPostCall = function sendRequest(url, data, done) {
    // console.log(data);
    return fetch(url,{
    method: 'GET',
    // mode: 'CORS',
     }).then(function(resp){
        // console.log(resp);
        return resp.json();
    });
};

exports.GetCallAPI = getApiPostCall;


// WEBPACK FOOTER //
// ./src/views/RestAPI/getData.js